module.exports = __webpack_public_path__ + "static/media/Sidharth.98e97e62.jpeg";